module.exports = __webpack_public_path__ + "static/media/qubit-logo.5ee32ac7.svg";